import React, { useEffect } from 'react';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';

import { updateExtraByName } from 'apps/auth/actions/extraAction';
import { changeFormField } from 'apps/auth/actions/formAction';
import { AML_LEVEL_STANDARD } from 'apps/auth/constants/Constants';
import { RECALCULATE } from 'apps/auth/constants/ExtraNames';
import { DELIVERY_METHOD } from 'apps/auth/constants/fieldsName';
import { USA } from 'apps/auth/constants/WellKnownCountries';
import update from 'apps/auth/helpers/Immutability';
import { useAuth, useExtra, useForm, useLanguage, usePageMessages } from 'apps/auth/hooks/selectors';
import { UsaService } from 'apps/auth/services/UsaService';

import DefaultPopup from './DefaultPopup';
import MultiplePopup from './MultiplePopup';
import ThreeMonthsPopup from './ThreeMonthsPopup';
import UsaPopup from './UsaPopup';

export const ErrorDetailsPopup = (props) => {
    const {
        isFrom = false,
        maxAmount,
        amountField,
        formName,
        isBonus,
        changeFormField,
        multiple,
        currencyCode,
        popupRef,
        updateExtraByName,
        decreaseAmountButtonClick,
    } = props;
    const { value } = amountField;

    const auth = useAuth();
    const messages = usePageMessages();
    const extra = useExtra();
    const { lang } = useLanguage();
    const form = useForm(formName);
    const { leftLimitAmount, profile, canMakeDraftTransaction } = extra;
    const isNoIdent = profile?.amlLimit?.currentLimit < AML_LEVEL_STANDARD;
    const isTransactionalLimits = maxAmount && value > maxAmount;
    const isThreeMonthLimits = profile?.threeMonthLimitEnabled && isNoIdent && !canMakeDraftTransaction;
    const isUsaLimits = auth?.countryId === USA && UsaService.isNewLimits(profile);
    const isMultiple = multiple && value % multiple !== 0;
    const deliveryMethod = form?.fields[DELIVERY_METHOD]?.value;

    useEffect(() => {
        props.sendAmplitudeEvent?.();
    }, []);

    const defaultDecreaseAmountButtonClick = (amountForChange) => {
        let min = maxAmount;
        if (amountForChange) {
            min = amountForChange;
        } else if (leftLimitAmount && !canMakeDraftTransaction) {
            min = Math.min(leftLimitAmount, maxAmount);
        }
        const newField = update(amountField, {
            $auto: {
                value: { $set: min },
                isError: { $set: false },
                error: {
                    $auto: {
                        code: { $set: '' },
                        body: { $set: '' },
                    },
                },
            },
        });
        changeFormField(formName, newField).then(() => updateExtraByName(RECALCULATE, true));
    };

    let Component;
    if (isMultiple) {
        Component = MultiplePopup;
    } else if (isUsaLimits) {
        Component = UsaPopup;
    } else if (isThreeMonthLimits) {
        Component = ThreeMonthsPopup;
    } else {
        // TransactionalLimits, Bonus and default
        Component = DefaultPopup;
    }

    return (
        <Component
            defaultDecreaseAmountButtonClick={defaultDecreaseAmountButtonClick}
            isTransactionalLimits={isTransactionalLimits}
            decreaseAmountButtonClick={decreaseAmountButtonClick}
            value={value}
            popupRef={popupRef}
            maxAmount={maxAmount}
            deliveryMethod={deliveryMethod}
            isFrom={isFrom}
            currencyCode={currencyCode}
            amountField={amountField}
            isBonus={isBonus}
            multiple={multiple}
            messages={messages}
            extra={extra}
            auth={auth}
            lang={lang}
        />
    );
};

ErrorDetailsPopup.propTypes = {
    isFrom: PropTypes.bool,
    isBonus: PropTypes.bool,
    decreaseAmountButtonClick: PropTypes.func,
    formName: PropTypes.string,
    amountField: PropTypes.object,
    maxAmount: PropTypes.number,
    multiple: PropTypes.number,
    currencyCode: PropTypes.string,
    popupRef: PropTypes.shape({ current: PropTypes.object }),
};

export default connect(null, { changeFormField, updateExtraByName })(ErrorDetailsPopup);
